import React from 'react'

const CalenderIconWMO = () => (

<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M19 4.00098H5C3.89543 4.00098 3 4.89641 3 6.00098V20.001C3 21.1055 3.89543 22.001 5 22.001H19C20.1046 22.001 21 21.1055 21 20.001V6.00098C21 4.89641 20.1046 4.00098 19 4.00098Z" stroke="#282832" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M15.9976 1.99902V5.99902" stroke="#282832" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M8.00244 1.99902V5.99902" stroke="#282832" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M3 10.001H21" stroke="#282832" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  
)
export default CalenderIconWMO